import React, { createContext, useState } from 'react'
import { useConversation } from '@gopeerproject/chuck'

export const ConversationContext = createContext()

export const ConversationContextProvider = ({ children, id }) => {
  const [visibility, setVisibility] = useState('public')
  const { data, isLoading, status } = useConversation(id)

  return (
    <ConversationContext.Provider
      value={{
        visibility,
        setVisibility,
        data,
        isLoading: isLoading,
        status
      }}
    >
      {children}
    </ConversationContext.Provider>
  )
}
